import { useCompany } from './useCompany';
import { useCompanyCanonicalUrl } from './useCompanyCanonicalUrl';
import { getSnowflakePoints } from './utils';

/**
 *
 * Return a company report summary info
 *
 * @param lookupValue
 *
 * * lookupValue accepts the following options
 *
 * * canonincal url of a company
 * * company id
 * * unique symbol
 *
 * If passing a blank `lookupValue` this will use current path as the canonical url
 * for fetching the company data.
 *
 */
export function useSummaryV2(lookupValue?: string) {
  const canonicalUrl = useCompanyCanonicalUrl();
  const companyQuery = useCompany(lookupValue || canonicalUrl);
  if (companyQuery.status === 'success') {
    const data = companyQuery.data.data;

    return {
      status: companyQuery.status,
      companyId: data.company_id,
      uniqueSymbol: data.unique_symbol,
      tickerSymbol: data.ticker_symbol,
      canonicalUrl: data.canonical_url,
      name: data.info.data.legal_name,
      coverImage: data.info.data.main_header,
      score: getSnowflakePoints(data),
    };
  }
  return { status: companyQuery.status };
}
